import { client } from 'app/api/_client';
import { FinancialStatementPdfResponse } from 'app/api/financial-statement/types';
import { Endpoints } from 'app/api/helpers';
import { getSlug } from 'app/util/headers';
import { logger } from 'app/util/logger';

/**
 * Requests on-demand PDF generation for a submitted financial statement.
 *
 * @param id - The UniversalLoanApplication ID returned after form submission.
 * @returns Response containing a base64-encoded PDF string to be passed directly to `downloadjs`.
 * @throws Re-throws any API error after logging it.
 */
export const generateFinancialStatementPdf = async (id: number): Promise<FinancialStatementPdfResponse> => {
  const params = { id, slug: getSlug() };

  return client.post<FinancialStatementPdfResponse>(Endpoints.FILE_GENERATION_FINANCIAL_STATEMENT, params)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      logger.error('Error in generateFinancialStatementPdf API call: ', { error });
      throw error;
    });
};
